import React, { useState, useEffect } from 'react';
import {
  Group,
  Title,
  Image,
  Modal,
  Space,
  Text,
  Stack,
  Box,
  Center,
  Button,
  // Select,
  Skeleton,
} from '@mantine/core';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
// import { ChevronDown } from 'tabler-icons-react';
// import { showNotification } from '@mantine/notifications';
import Logo from '../../image/mouqfi.png';
import { sendRequest } from '../../services/services';
import CashierAmount from '../PaymentStatus/CashierPrint';
import TimerEvent from '../../components/TimerEvent/TimerEvent';

const Profile = () => {
  const navigate = useNavigate();
  const [opened, setOpened] = useState(false);
  const [profileData, setProfileData] = useState({});
  const [totalAmountData, setTotalAmountData] = useState();
  const [isLoading, setIsLoading] = useState(false);

  const [timerActivated, setTimerActivated] = useState(false);

  const SIX_HOURS_IN_MS = 6 * 60 * 60 * 1000;
  const currentTime = Date.now();
  const lastLoginTime = new Date(profileData?.last_login_at).getTime() || 0;
  const timePassed = currentTime - lastLoginTime;

  const fetchProfile = () => {
    setIsLoading(true);
    sendRequest(`cashier/profile`, 'get')
      .then((res) => {
        setProfileData(res?.data || []);
      })
      .catch((err) => {
        if (err?.response?.data?.code) {
          // eslint-disable-next-line no-console
          console.log('err', err?.response?.data?.code);
          if (err?.response?.data?.code === 43) {
            navigate('/');
            localStorage.setItem('token', '');
            localStorage.setItem('userData', '');
          }
        }
      })
      .finally(() => {
        setIsLoading(false); // Set isLoading to false after fetching data
      });
  };

  const fetchTotalAmount = () => {
    setIsLoading(true);
    sendRequest(`cashier/collect-payment`, 'get')
      .then((res) => {
        setTotalAmountData(res?.data || []);
      })
      .finally(() => {
        setIsLoading(false); // Set isLoading to false after fetching data
      });
  };
  useEffect(() => {
    fetchProfile();
    fetchTotalAmount();
    setTimeout(fetchProfile(), 2000);
    setTimeout(fetchTotalAmount(), 2000);
  }, []);

  // const status = `?is_online=${!profileData?.is_online}`;
  // const shiftUpdate = () => {
  //   sendRequest(`/cashier/change-status${status}`, 'post')
  //     .then(({ msg }) => {
  //       if (msg === 'Profile online status updated successfully!') {
  //         fetchProfile();
  //         fetchTotalAmount();
  //       }
  //     })
  //     .catch((err) => {
  //       if (err?.response?.data?.code) {
  //         // eslint-disable-next-line no-console
  //         console.log('err', err?.response?.data?.code);
  //       }
  //     });
  // };

  useEffect(() => {
    const interval = setInterval(() => {
      if (timePassed >= SIX_HOURS_IN_MS) {
        setTimerActivated(true);
        // eslint-disable-next-line no-console
        console.log('Working Conditions');
      }
      // eslint-disable-next-line no-console
      console.log('Working', timePassed >= SIX_HOURS_IN_MS);
    }, 1000);
    return () => clearInterval(interval);
  }, [timePassed]);

  useEffect(() => {
    fetchProfile();
    fetchTotalAmount();
    setTimeout(fetchProfile(), 2000);
    setTimeout(fetchTotalAmount(), 2000);
  }, []);

  return (
    <Box>
      <Stack>
        <Center>
          <Image src={Logo} width={130} />
        </Center>
        <Skeleton height={13} radius="xl" visible={isLoading}>
          <Title order={5}>Welcome: {profileData?.name}</Title>
        </Skeleton>
        <Space h="sm" />
        <Skeleton height={13} radius="xl" visible={isLoading}>
          <Title order={6}>
            Shift Start Time: {dayjs(profileData?.online_from).format('hh:mma DD/MM/YY')}
          </Title>
        </Skeleton>
        <Space h="sm" />
        <Group>
          <Title order={5}>Status:</Title>
          <Title order={5} style={{ color: 'green' }}>
            {profileData?.is_online === true ? 'Online' : 'Offline'}
          </Title>
          {/* <Select
            sx={{ width: '100px' }}
            data={[
              { value: '1', label: 'Online' },
              { value: '2', label: 'Offline' },
            ]}
            rightSection={<ChevronDown size={14} />}
            onChange={() => shiftUpdate()}
            value={profileData?.is_online === true ? '1' : '2'}
          /> */}
        </Group>

        {timerActivated ? (
          <Center>
            <TimerEvent />
          </Center>
        ) : null}
      </Stack>
      <Space h="sm" />
      <Stack>
        <Title order={6}>Amount collected in cash</Title>
        <Skeleton height={13} radius="xl" visible={isLoading}>
          <Center>
            {profileData?.is_online === true && profileData?.online_from ? (
              <Title order={2}>
                {Number(totalAmountData?.cash).toLocaleString('en-US', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}{' '}
                SAR
              </Title>
            ) : (
              <Title order={2}>{0.0} SAR</Title>
            )}
          </Center>
        </Skeleton>
        <Title order={6}>Amount collected by card</Title>
        <Skeleton height={13} radius="xl" visible={isLoading}>
          <Center>
            {profileData?.is_online === true && profileData?.online_from ? (
              <Title order={2}>
                {Number(totalAmountData?.card).toLocaleString('en-US', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}{' '}
                SAR
              </Title>
            ) : (
              <Title order={2}>{0.0} SAR</Title>
            )}
          </Center>
        </Skeleton>
      </Stack>
      <Space h="xl" />
      <Center>
        <Button
          style={{ backgroundColor: '#D9D9D9', color: 'black', width: 180 }}
          width="100%"
          onClick={() => setOpened(true)}
        >
          Shift End
        </Button>
      </Center>

      <Modal
        opened={opened}
        centered
        onClose={() => setOpened(false)}
        title={
          <Text p="xl" className="no-printme">
            {profileData?.is_online === true
              ? 'You want to end the shift'
              : 'You want to start the shift'}
          </Text>
        }
      >
        <Center>
          <Group>
            <CashierAmount profile={profileData} amountTotal={totalAmountData} />
          </Group>
        </Center>
      </Modal>
    </Box>
  );
};

export default Profile;
